import React, { useContext } from 'react';
import noteContext from '../Context/NoteContext';
import styles from "./EditForm.module.css"

export default function EditForm() {
    const {
        setExpenseList,
        categories, setCategories,
        setisModal,
        setModalType,
        edittmp, setedittmp,
        ind
    } = useContext(noteContext);

    const modalHandle = () => {
        setModalType("editCategory");
    };

    /* Edit save Function */
    function editSave() {
        setExpenseList(prevList => {
            const updatedList = [...prevList];
            // Merge the current edited values with the newly selected category
            updatedList[ind] = {
                ...edittmp,
                category: categories.name ? categories : edittmp.category
            };
            return updatedList;
        });

        // Cleanup and Close
        setedittmp({});
        setCategories({});
        setisModal(false);
    }

    return (
        <div className={styles.edit}>
            <div>
                <label htmlFor="editinp"></label>
                <input
                    style={{ textAlign: "center", border: "0.5px solid black" }}
                    type="text"
                    name="editinp"
                    id="editinp"
                    placeholder="Amount"
                    value={edittmp?.amount || ""}
                    onChange={(e) => setedittmp({ ...edittmp, amount: e.target.value })}
                />
            </div>
            <div className={styles.inner}>
                <label htmlFor="newExpense">Expense</label>
                <input
                    type="radio"
                    name="newType"
                    id="newExpense"
                    value="Expense"
                    checked={edittmp?.type === "Expense"}
                    onChange={(e) => setedittmp({ ...edittmp, type: e.target.value })}
                />
                <label htmlFor="newIncome">Income</label>
                <input
                    type="radio"
                    name="newType"
                    id="newIncome"
                    value="Income"
                    checked={edittmp?.type === "Income"}
                    onChange={(e) => setedittmp({ ...edittmp, type: e.target.value })}
                />

                <input
                    style={{ textAlign: "center", border: "0.5px solid black" }}
                    type="text"
                    name="editDescription"
                    id="editDescription"
                    placeholder="Description"
                    value={edittmp?.description || ""}
                    onChange={(e) => setedittmp({ ...edittmp, description: e.target.value })}
                />

                <input
                    type="date"
                    name="newdate"
                    id="newdate"
                    value={edittmp?.date || ""}
                    onChange={(e) => setedittmp({ ...edittmp, date: e.target.value })}
                />


                <button type="button" onClick={modalHandle}>Select Category</button>
                <div>
                    {/* Show new selection if picked, otherwise show original */}
                    {categories.name ? categories.icon : edittmp?.category?.icon}
                    {categories.name ? categories.name : edittmp?.category?.name}
                </div>

                <button
                    onClick={editSave}
                    disabled={!edittmp?.amount || (!categories.name && !edittmp?.category)}
                >
                    Save
                </button>
            </div>
        </div>
    );
}